// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"174":"77f3c853","281":"9afb6be3","506":"f662c37c","852":"eec40e79"}[chunkId] + ".css";
};